import React from "react";
import Card from "@material-ui/core/Card";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import { Button } from "@material-ui/core";

const Demo = () => {
  const classes = getMakeStyleClasses(compClasses);

  return (
    <section className={classes.contentContainer}>
      <Card className={classes.overrideCard}>
        <div
          style={{
            fontSize: "10rem",
          }}
        >
          404
        </div>
        <div
          style={{
            fontSize: "3rem",
          }}
        >
          Not Found
        </div>
        <div>
          <Button
            className={classes.button}
            onClick={() => window.history.back()}
            variant="contained"
            size="small"
            color="primary"
          >
            Back Home
          </Button>
        </div>
      </Card>
    </section>
  );
};

export default Demo;

const compClasses = (theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    margin: "0 10px 10px 0",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      cursor: "default",
    },
  },
  // iconDetailOverride: {
  //   height: "0.7em",
  //   width: "0.7em",
  // },
  contentContainer: {
    height: "100%",
  },
  overrideCard: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    color: theme.palette.primary.main,
  },
});
